import { useCallback, useState } from 'react'
import { ModelOptions } from 'src/components/CustomTable'

const STORAGE_KEY = 'congado:view-mode:animal'

export const useAnimalViewMode = () => {
  const [tableViewMode, setTableViewMode] = useState<ModelOptions>(() => {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'card' || stored === 'table') return stored
    return 'table'
  })
  const [filterIsActiver, setFilterIsActiver] = useState(false)

  const changeTableViewMode = useCallback((mode: ModelOptions) => {
    localStorage.setItem(STORAGE_KEY, mode)
    setTableViewMode(mode)
  }, [])

  const handleFilterActiver = useCallback((value: boolean) => {
    setFilterIsActiver(value)
  }, [])

  return {
    tableViewMode,
    filterIsActiver,
    changeTableViewMode,
    handleFilterActiver
  }
}
